export const isMtnNumber = (phoneNumber) => {
    const regex = /^07[8,9][0-9]{7}/;

    return regex.test(phoneNumber);
}